import * as React from 'react';
import { ReactComponent as WhatsappIconSVG } from '../../assets/icons/mevo/ic_whatsapp.svg';
import IconPattern, { IconProps } from './_IconPattern';

const WhatsappIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={WhatsappIconSVG} variantPlaces={[1, 2]} {...props} />;
};

export default WhatsappIcon;
